import { useCallback } from "react";
import { useViewportDimension } from "./__internal__/useViewportDimension";
export var useViewportWidth = function(deriveFromWidth) {
    var deriveFromDimension = useCallback(function(param) {
        var width = param.width;
        return deriveFromWidth(width);
    }, [
        deriveFromWidth
    ]);
    return useViewportDimension(deriveFromDimension);
};
